<template>
	<div class="application-page jobs">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation
						page="jobs"
						:only="loading || jobForOnboarding ? ['logout'] : undefined"
					/>
				</b-col>
				<b-col md="7">
					<Loading v-if="loading"/>
					<template v-else>
						<h1>{{ jobForOnboarding ? ('Hallo ' + application.firstName + '!') : 'Matches' }}</h1>
						<Onboarding
							v-if="jobForOnboarding"
							:job="jobForOnboarding"
							:application-data="applicationData"
							@continueLater="onContinueLater"
							@close="onClose"
						/>
						<Listing
							v-else-if="!loadingJobs || initiallyLoadedJobs"
							:jobs="jobs"
							:loading-jobs="loadingJobs"
							:jobs-to-show-results-for="jobsToShowResultsFor"
							:class="{'loading-blockaed': loadingJobs}"
							@publish="loadJobs"
							@unpublish="loadJobs"
							@save="loadJobs"
							@jobChanged="loadJobs"
							@messagesClosed="loadJobs"
						/>
					</template>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/application/profile/Navigation";
import GetList from "@/api/application/job/GetList";
import {mapActions, mapState} from "vuex";
import Loading from "@/vue/common/Loading";
import _ from "lodash";
import Listing from "@/vue/application/job/Listing"
import Onboarding from "@/vue/application/job/bot/Onboarding";
import {isDefined} from "@/helper/Value";
import {getQueryParams, removeQueryParamsFromUrl} from "@/helper/Url";
import {INITIATOR_APPLICANT} from "@/store/communication/conversation/messages";
import {LIST_TYPE__APPLICANT} from "@/store/communication/appointment";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		Onboarding,
		Loading,
		Navigation,
		Listing,
	},

	props: {
		applicationData64: {
			type: String,
			required: true,
		},
	},

	async mounted ()
	{
		this.loadJobs();

		const queryParams = getQueryParams();

		if (queryParams.trackPageVisitEvent)
		{
			Event.push(
				new EventData()
					.setEvent(Event.PAGE_VISIT)
					.setAction('Matches')
			);

			removeQueryParamsFromUrl();
		}

		if (queryParams.showMessages || queryParams.showAppointments)
		{
			const id = queryParams.showMessages || queryParams.showAppointments;

			if (queryParams.showAppointments)
			{
				await this.openAppointmentFan({
					listType: LIST_TYPE__APPLICANT,
					jobId: id
				});
			}

			if (queryParams.showMessages)
			{
				const response = await new GetList()
					.setJob(queryParams.showMessages)
					.call();

				const job = _.first(response.data);

				if (job)
				{
					await this.openMessagesFan({
						applicantData: {
							job
						},
						initiator: INITIATOR_APPLICANT
					});
				}
			}

			removeQueryParamsFromUrl();
		}
	},

	data ()
	{
		let applicationData = {};

		if (this.applicationData64)
		{
			applicationData = JSON.parse(
				window.atob(this.applicationData64)
			);
		}

		return {
			applicationData,
			jobs: null,
			loadingJobs: true,
			initiallyLoadedJobs: false,
			saving: false,
			jobsToShowResultsFor: [],
		};
	},

	computed: {
		...mapState('meta', [
			'meta'
		]),
		...mapState('auth', [
			'application',
			'internal'
		]),
		loading ()
		{
			if (!this.application)
			{
				return true;
			}

			return this.loadingJobs && !this.initiallyLoadedJobs;
		},
		jobForOnboarding ()
		{
			if (this.internal)
			{
				return undefined;
			}

			if (!this.jobs || this.jobs.length !== 1)
			{
				return undefined;
			}

			const job = _.first(this.jobs);

			return !job.questionnaire.finished
				? job
				: undefined;
		},
	},

	methods: {
		...mapActions('communication/conversation/messages', {
			openMessagesFan: 'show',
		}),
		...mapActions('communication/appointment', {
			openAppointmentFan: 'show',
		}),
		onContinueLater ({job})
		{
			const isIn = isDefined(
				_.find(this.jobsToShowResultsFor, j => j.id === job.id)
			);

			if (!isIn)
			{
				this.jobsToShowResultsFor.push(job);
			}
		},
		onClose ()
		{
			this.loadJobs();
		},
		async loadJobs ()
		{
			this.loadingJobs = true;

			const response = await new GetList()
				.call();

			this.jobs = response.data;

			this.loadingJobs = false;
			this.initiallyLoadedJobs = true;
		},
	}
}
</script>
